import axiosInstance from "./axios";

export class ExamenService {
    // Exámenes Virtuales
    getExamenesVirtuales() {
        return axiosInstance
            .get("/examen")
            .then((res) => res.data)
    }

    addExamenVirtual(dto) {
        return axiosInstance
            .post("/examen", dto)
            .then((res) => res.data)
    }

    updateExamenVirtual(dto) {
        return axiosInstance
            .put(`/examen/${dto._id}`, dto)
            .then((res) => res.data)
    }

    // Exámenes Presenciales
    getExamenesPresenciales() {
        return axiosInstance
            .get("/examenpresencial")
            .then((res) => res.data)
    }

    addExamenPresencial(dto) {
        return axiosInstance
            .post("/examenpresencial", dto)
            .then((res) => res.data)
    }

    updateExamenPresencial(dto) {
        return axiosInstance
            .put(`/examenpresencial/${dto._id}`, dto)
            .then((res) => res.data)
    }

    deleteExamenPresencial(id) {
        return axiosInstance
            .delete(`/examenpresencial/${id}`)
            .then((res) => res.data)
    }

    // Ranking y Notas
    getRankingVirtual(examenId) {
        return axiosInstance
            .get(`/examen/ranking/${examenId}`)
            .then((res) => res.data)
    }

    getNotasPresencial(idExamen) {
        return axiosInstance
            .get(`/examenpresencialalumno`, { params: { examenespresencial: idExamen } })
            .then((res) => res.data)
    }

    uploadNotasExcel(idExamen, idCiclo, formData) {
        return axiosInstance
            .post(`/examenpresencialalumno/importnotas/${idExamen}/${idCiclo}`, formData)
            .then((res) => res.data);
    }

    getSemanas() {
        return axiosInstance
            .get("/tablamaestra", { params: { idtabla: 2 } })
            .then((res) => res.data)
    }

    getRankingFecha(semanaId) {
        return axiosInstance
            .get("/alumnoexamen/ranking", { params: { semana: semanaId } })
            .then((res) => res.data)
    }
}
